// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"__500_wrapper__msyTt","h1":"__500_h1__HtvlF","p":"__500_p__LX_z_","a":"__500_a__WJVbl"};